import { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/Home';
import Stores from './pages/Stores';
import Cart from './pages/Cart';
import Details from './pages/Details';
import Register from './pages/Register';
import Login from './pages/Login';
import Shipping from './pages/Shipping';
import { useDispatch } from 'react-redux';
import { get_category } from './store/reducers/homeReducer'
import CategoryShops from './pages/CategoryShop';
import SearchProducts from './pages/SearchProducts';
import Payment from './pages/Payment';
import Dashboard from './pages/Dashboard';
import ProtectUser from './utils/ProtectUser';
import Index from './components/dashboard/Index';
import Orders from './components/dashboard/Orders';
import Wishlist from './components/dashboard/Wishlist';
import ChangePassword from './components/dashboard/UpdateAccountInfo';
import Order from './components/dashboard/Order';
import Chat from './components/dashboard/Chat';
import CustomerNotifications from './components/dashboard/NotificationsDark'
import SupportTickets from './components/dashboard/SupportTickets';
import Referral from './components/dashboard/Referral';
import ReturnRequests from './components/dashboard/ReturnRequests';
import MyInstallments from './components/dashboard/MyInstallments';
import ConfirmOrder from './pages/ConfirmOrder';
import StoreDetails from './pages/StoreDetails'; 
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import UpdateAccountInfo from './components/dashboard/UpdateAccountInfo';
import AboutUs from './pages/AboutUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ReturnRefundPolicy from './pages/ReturnRefundPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import PaymentCallback from './pages/PaymentCallback';
import TopBar from './components/TopBar';
import ScrollToTop from './components/ScrollToTop';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import { useNavigate, useParams } from 'react-router-dom';

// Resolves /join/:slug → extracts ref code from slug and redirects to /register?ref=CODE
function JoinRedirect() {
  const { slug } = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    const parts = (slug || '').split('-')
    const codeSuffix = parts[parts.length - 1].toUpperCase()
    // Try to resolve via backend, fallback to just passing the suffix as ref
    fetch(`${process.env.REACT_APP_SERVER_URL}/api/join/${slug}`)
      .then(r => {
        // Backend returns a redirect; get the final URL from the response URL
        if (r.url && r.url.includes('ref=')) {
          const ref = new URL(r.url).searchParams.get('ref')
          if (ref) return navigate(`/register?ref=${ref}`, { replace: true })
        }
        navigate(`/register?ref=${codeSuffix}`, { replace: true })
      })
      .catch(() => navigate(`/register?ref=${codeSuffix}`, { replace: true }))
  }, [slug, navigate])
  return null
}
function App() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(get_category())
  }, [])

  // IP-based country/currency detection — runs once per day, cached in localStorage
  useEffect(() => {
    const cached = localStorage.getItem('omah_detected_currency')
    const cachedAt = localStorage.getItem('omah_detected_at')
    const ONE_DAY = 24 * 60 * 60 * 1000
    if (!cached || !cachedAt || Date.now() - parseInt(cachedAt, 10) > ONE_DAY) {
      fetch(`${process.env.REACT_APP_SERVER_URL}/api/detect-country`)
        .then(r => r.json())
        .then(({ currency, countryCode }) => {
          if (currency) {
            localStorage.setItem('omah_detected_currency', currency)
            localStorage.setItem('omah_detected_country', countryCode || '')
            localStorage.setItem('omah_detected_at', String(Date.now()))
          }
        })
        .catch(() => {})
    }
  }, [])

  return (
    <BrowserRouter>
      <ScrollToTop />
      <PWAInstallPrompt />
      <TopBar />
      <Routes>
        <Route path='/register' element={<Register />} />
        <Route path='/login' element={<Login />} />
        <Route path='/forgotpassword' element={<ForgotPassword />} />
        <Route path='/resetpassword' element={<ResetPassword />} />
        <Route path='/' element={<Home />} />
        <Route path='/stores' element={<Stores />} />
        <Route path="/stores/:storename/:storeid" element={<StoreDetails />} />
        <Route path='/products?' element={<CategoryShops />} />
        <Route path='/products/search?' element={<SearchProducts />} />
        <Route path='/Cart' element={<Cart />} />
        <Route path='/order/confirm?' element={<ConfirmOrder />} />
        <Route path='/shipping' element={<Shipping />} />
        <Route path='/payment' element={<Payment />} />
        <Route path='/payment/callback' element={<PaymentCallback />} />
        <Route path='/product/details/:slug' element={<Details />} />

        <Route path='/dashboard' element={<ProtectUser />}>
          <Route path='' element={<Dashboard />}>
            <Route path='' element={<Index />} />
            <Route path='my-orders' element={<Orders />} />
            <Route path='account' element={<UpdateAccountInfo />} />
            <Route path='my-wishlist' element={<Wishlist />} />
            <Route path='order/details/:orderId' element={<Order />} />
            <Route path='chage-password' element={<ChangePassword />} />
            <Route path='notifications' element={<CustomerNotifications />} />
            <Route path='chat' element={<Chat />} />
            <Route path='chat/:sellerId' element={<Chat />} />
            <Route path='support' element={<SupportTickets />} />
            <Route path='referral' element={<Referral />} />
            <Route path='my-returns' element={<ReturnRequests />} />
            <Route path='my-installments' element={<MyInstallments />} />
          </Route>
        </Route>

        {/* Policy Pages */}
        <Route path='/about-us' element={<AboutUs />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/return-refund-policy' element={<ReturnRefundPolicy />} />
        <Route path='/terms-and-conditions' element={<TermsAndConditions />} />

        {/* Referral slug redirect: /join/name-CODE6 → /register?ref=CODE via backend */}
        <Route path='/join/:slug' element={<JoinRedirect />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
